module.exports = __webpack_public_path__ + "img/stock2.af85fd46.png";